import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormControl, FormGroup, Col, ControlLabel, Button, Image, Alert, Row } from 'react-bootstrap';
import VirtualizedSelect from 'react-virtualized-select';
import months from './data/months.js';
import years from './data/years.js';
import asyncValidate from '../../asyncValidate';
import './styles.css';
import visa from './visa.png';
import mastercard from './mastercard.png';
import discover from './discover.png';

const validate = values => {
  const errors = {};

  if (!values.firstName) {
    errors.firstName = 'Required';
  }
  if (!values.lastName) {
    errors.lastName = 'Required';
  }
  if (!values.postcode) {
    errors.postcode = 'Required';
  }
  if (!values.address1) {
    errors.address1 = 'Required';
  }
  if (!values.city) {
    errors.city = 'Required';
  }
  if (!values.creditCardType) {
    errors.creditCardType = 'Required';
  }
  if (!values.creditCardNumber) {
    errors.creditCardNumber = 'Required';
  }
  if (!values.validYears) {
    errors.validYears = 'Required';
  }
  if (!values.validMonths) {
    errors.validMonths = 'Required';
  }
  if (!values.cvv2Number) {
    errors.cvv2Number = 'Required';
  }
  if (!values.expDateMonth) {
    errors.expDateMonth = 'Required';
  }
  if (!values.expDateYear) {
    errors.expDateYear = 'Required';
  }
  if (!values.nameOnCard) {
    errors.nameOnCard = 'Required';
  }
  return errors;
};

const warn = values => {
  const warnings = {};
  return warnings;
};

const renderField = ({ feedbackIcon, input, label, type, meta: { touched, error, warning, asyncValidating } }) => {
  const validationState = (touched && (error && 'error')) || (warning && 'warning') || null;
  const style = { margin: '10px 0', borderRadius: 0, color: '#265886' };

  return (
    <FormGroup controlId={input.name} validationState={validationState}>
      <Col componentClass={ControlLabel} xs={12} md={5} className="text-right">
        <div style={style}>
          <h4>
            {label}
            <span style={{ color: 'red' }}> *</span>
          </h4>
        </div>
      </Col>
      <Col xs={12} md={7}>
        <FormControl {...input} placeholder={label} type={type} style={style} />
        {asyncValidating ? (
          <FormControl.Feedback style={{ width: '34px', height: 'inherit', right: '25px', top: '20px' }}>
            <i className="fa fa-spinner fa-spin" />
          </FormControl.Feedback>
        ) : null}
        {feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
        {touched &&
          ((error && <span className="help-block text-left">{error}</span>) ||
            (warning && <span className="help-block text-left">{warning}</span>))}
      </Col>
    </FormGroup>
  );
};

const renderSelect = ({
  options,
  placeholder,
  feedbackIcon,
  input,
  label,
  type,
  lastBlurredField,
  meta: { touched, error, warning, asyncValidating }
}) => {
  const validationState = (touched && (error && 'error')) || (warning && 'warning') || null;
  const style = { margin: '10px 0', borderRadius: 0, color: '#265886' };

  return (
    <FormGroup controlId={input.name} validationState={validationState}>
      <Col xs={12} className="text-left">
        <VirtualizedSelect
          value={input.value}
          onChange={value => input.onChange(value)}
          onBlur={() => input.onBlur(input.value)}
          simpleValue
          options={options}
          style={style}
          placeholder={placeholder}
          onFocus={() => lastBlurredField(input.name)}
        />
        {asyncValidating ? (
          <FormControl.Feedback style={{ right: '25px', top: '20px' }}>
            <i className="fa fa-spinner fa-spin" />
          </FormControl.Feedback>
        ) : null}
        {feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
        {touched &&
          ((error && <span className="help-block text-left">{error}</span>) ||
            (warning && <span className="help-block text-left">{warning}</span>))}
      </Col>
    </FormGroup>
  );
};

const renderSelectTwo = ({
  options,
  placeholder,
  feedbackIcon,
  input,
  label,
  type,
  lastBlurredField,
  meta: { touched, error, warning, asyncValidating }
}) => {
  const validationState = (touched && (error && 'error')) || (warning && 'warning') || null;
  const style = { margin: '10px 0', borderRadius: 0, color: '#265886' };

  return (
    <FormGroup controlId={input.name} validationState={validationState}>
      <Col componentClass={ControlLabel} xs={12} md={5} className="text-right">
        <div style={style}>
          <h4>
            {label}
            <span style={{ color: 'red' }}> *</span>
          </h4>
        </div>
      </Col>
      <Col xs={12} md={7} className="text-left">
        <VirtualizedSelect
          value={input.value}
          onChange={value => input.onChange(value)}
          onBlur={() => input.onBlur(input.value)}
          simpleValue
          options={options}
          style={style}
          placeholder={placeholder}
          labelKey="name"
          valueKey="code"
          onFocus={() => lastBlurredField(input.name)}
        />
        {asyncValidating ? (
          <FormControl.Feedback style={{ right: '25px', top: '20px' }}>
            <i className="fa fa-spinner fa-spin" />
          </FormControl.Feedback>
        ) : null}
        {feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
        {touched &&
          ((error && <span className="help-block text-left">{error}</span>) ||
            (warning && <span className="help-block text-left">{warning}</span>))}
      </Col>
    </FormGroup>
  );
};

const SyncValidationForm = props => {
  const { handleSubmit, submitting, error } = props;
  return (
    <form onSubmit={handleSubmit} className="payment-form">
      <Col xs={12} style={{ margin: '25px 0' }} className="card-images">
        <Col xs={4} style={{ marginTop: '10px' }}>
          <Image src={visa} />
        </Col>
        <Col xs={4}>
          <Image src={mastercard} />
        </Col>
        <Col xs={4}>
          <Image src={discover} />
        </Col>
      </Col>
      <Field
        name="creditCardType"
        type="select"
        component={renderSelectTwo}
        options={props.info.paymentCardTypes}
        placeholder="Select a card type"
        label="Select Card"
        lastBlurredField={props.lastBlurredField}
      />

      <Field
        id="credit-card-number"
        name="creditCardNumber"
        type="text"
        component={renderField}
        label="Card Number"
        inputmode="numeric"
        onFocus={() => props.lastBlurredField('creditCardNumber')}
      />
      <div className="">
        <Col componentClass={ControlLabel} xs={12} md={5} className="text-right">
          <div style={{ margin: '10px 0', borderRadius: 0, color: '#265886' }}>
            <h4>
              Valid to:
              <span style={{ color: 'red' }}> *</span>
            </h4>
          </div>
        </Col>
        <div className="valid-to">
          <Col xs={5} md={3} style={{ paddingLeft: '15px' }}>
            <Field
              name="validMonths"
              type="select"
              component={renderSelect}
              placeholder="MM"
              options={months}
              lastBlurredField={props.lastBlurredField}
            />
            <h4 className="text-left" style={{ color: '#cacaca', marginBottom: '0' }}>
              MM
            </h4>
          </Col>
          <Col xs={2} md={1} />
          <Col xs={5} md={3} style={{ paddingRight: '15px' }}>
            <Field
              name="validYears"
              type="select"
              component={renderSelect}
              placeholder="YYYY"
              options={years}
              lastBlurredField={props.lastBlurredField}
            />
            <h4 className="text-left" style={{ color: '#cacaca', marginBottom: '5px' }}>
              YYYY
            </h4>
          </Col>
        </div>
      </div>
      <Field
        name="cvv2Number"
        type="text"
        component={renderField}
        label="CVV"
        onFocus={() => props.lastBlurredField('cvv2Number')}
      />
      <Field
        name="nameOnCard"
        type="text"
        component={renderField}
        label="Name on card"
        onFocus={() => props.lastBlurredField('nameOnCard')}
      />
      <Col xs={12} mdOffset={5} md={7} className="confirm-button">
        <Button
          bsSize="large"
          bsStyle="success"
          type="submit"
          disabled={submitting}
          style={{ margin: '15px 0', borderRadius: 0, padding: '12px 12px', width: '100%', cursor: 'pointer' }}
          onClick={() => props.lastBlurredField('submit')}
        >
          CONFIRM BOOKING {props.payment.makePayment.isLoading ? <i className="fa fa-spinner fa-spin" /> : null}
        </Button>

        {/* {error && (
          <div style={{ textAlign: 'justify', paddingBottom: '10px' }}>
            <strong style={{ color: 'red' }}>{error}</strong>
          </div>
        )} */}
        {error && (
          <Row className="">
            <Col>
              <Alert bsStyle="success">
                {error ? <h4>Payment Error</h4> : null}
                <p
                  dangerouslySetInnerHTML={{
                    __html: error
                  }}
                />
              </Alert>
            </Col>
          </Row>
        )}
        <div className="text-center" style={{ marginTop: '-10px', color: '#666666' }}>
          <h6>Your information is secure</h6>
          <a href="https://www.ski-lifts.com/privacy/" target="_blank" rel="noopener noreferrer">
            <u style={{ color: '#666666' }}>
              <h6 style={{ marginTop: '-5px', color: '#666666' }}>Privacy policy</h6>
            </u>
          </a>
        </div>
      </Col>
    </form>
  );
};

export default reduxForm({
  form: 'payment', // a unique identifier for this form
  asyncValidate,
  validate, // <--- validation function given to redux-form
  warn // <--- warning function given to redux-form
})(SyncValidationForm);



// WEBPACK FOOTER //
// ./src/containers/PaymentPage/CardDetails/form/index.js